import { Col } from 'antd';
import styled from 'styled-components';
import { LEFT_COL_WIDTH } from 'utils/constants';
import { cssMediaBreakpoints } from 'utils/responsiveQuery/breakpoints';

export const MapAndResourcesCol = styled(Col)`
  height: calc(100vh - 170px);
  flex: 1;
  ${cssMediaBreakpoints.mobileOrTablet} {
    height: auto;
  }
`;

export const LeftCol = styled(Col)`
  padding-bottom: 6px;
  width: ${LEFT_COL_WIDTH};
  max-height: calc(100vh - 170px);
  overflow-y: auto;
  overflow-x: hidden;

  ${cssMediaBreakpoints.mobileOrTablet} {
    min-width: 100%;
    max-height: unset;
  }
`;
